import 'bootstrap/dist/css/bootstrap.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';


export const apiURL = process.env.NODE_ENV && process.env.NODE_ENV === "development" ? "https://Preprod.smcinsurance.com/HomeInsuranceAPI/" : "https://www.smcinsurance.com/HomeInsuranceAPI/";
export const baseUrl = process.env.NODE_ENV && process.env.NODE_ENV === "development" ? "" : "/homeinsurance/";
export const ckycURL = process.env.NODE_ENV && process.env.NODE_ENV === "development" ? "https://uat.smcinsurance.com/ckycapi/" : "https://coreapi.smcinsurance.com/ckyc/";
const rootElement = document.getElementById('root');

ReactDOM.render(
  <BrowserRouter basename={baseUrl}>
    <App/>
  </BrowserRouter>,
  rootElement);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister();

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
